import React, { useRef } from "react";
import { Container } from "react-bootstrap";
import SectionTitle from "../../common/SectionTitle/SectionTitle";
import InteriorCard from "../../cards/InteriorCard/InteriorCard";
import "./InteriorSection.css";
import { useTranslation } from "react-i18next";

export default function InteriorsSection({ vehicle }) {
    const { t } = useTranslation();

    const interiors = vehicle.interiors || [];
    const sliderRef = useRef(null);

    if (!interiors.length) return null;

    const scrollByAmount = (direction) => {
        if (!sliderRef.current) return;
        const slider = sliderRef.current;

        // scroll roughly 1.2 cards worth
        const cardWidth = slider.firstChild?.getBoundingClientRect().width || 280;
        const scrollAmount = cardWidth * 1.2;

        slider.scrollBy({
            left: direction === "right" ? scrollAmount : -scrollAmount,
            behavior: "smooth",
        });
    };

    return (
        <section className="interiors-section section-spacing">
            <Container fluid>
                <div className="text-center">
                    <SectionTitle
                        subtitle={t("vehicleInteriors.subtitle")}
                        title={t("vehicleInteriors.title")}
                    />
                </div>

                <div className="interiors-section__slider-wrapper">
                    <div className="interiors-section__slider" ref={sliderRef}>
                        {interiors.map((item) => {
                            const itemTitle = item.titleKey ? t(item.titleKey) : item.title || "";
                            const itemDesc = item.descriptionKey
                                ? t(item.descriptionKey)
                                : item.description || "";

                            return (
                                <div key={item.id} className="interiors-section__slide">
                                    <InteriorCard
                                        imageSrc={item.imageSrc}
                                        title={itemTitle}
                                        description={itemDesc}
                                    />
                                </div>
                            );
                        })}
                    </div>
                </div>

                <div className="text-center">
                    <div className="interiors-section__controls">
                        <button
                            type="button"
                            className="interiors-section__arrow"
                            onClick={() => scrollByAmount("left")}
                            aria-label={t("vehicleInteriors.ariaLeft")}
                        >
                            ‹
                        </button>
                        <button
                            type="button"
                            className="interiors-section__arrow"
                            onClick={() => scrollByAmount("right")}
                            aria-label={t("vehicleInteriors.ariaRight")}
                        >
                            ›
                        </button>
                    </div>
                </div>
            </Container>
        </section>
    );
}